<template>
<div class="testPage">
    <Row class="resultBox">
        <div class="result">
            <Col span="6">
                <Card>
                    <p slot="title">考生信息</p>
                    <p>姓名：{{testInfo.userName}}</p>
                    <p>公司：{{testInfo.companyName}}</p>
                    <p>职务：{{testInfo.postName}}</p>
                    <p>手机：{{testInfo.phone}}</p>
                </Card>
            </Col>
            <Col span="6">
                <Card dis-hover>
                    <p slot="title">考试信息</p>
                    <p>开卷时间：{{testInfo.startTime}}</p>
                    <p>交卷时间：{{testInfo.endTime}}</p>
                    <p>考试用时：{{testInfo.examTime}}</p>
                    <p>答题总数：{{testInfo.multipleCount + testInfo.radioCount}}</p>
                </Card>
            </Col>   
        </div>

        <div class="score">
            <span>总分</span>
            <p>{{testInfo.score}}</p>
        </div>
        
        <div class="result">
            <Col span="6">
                <Card dis-hover>
                    <p slot="title">单选题</p>
                    <p>题目总数：{{testInfo.radioCount}}</p>
                    <p>正确数量：{{testInfo.radioRate}}</p>
                    <p>正确率：{{testInfo.radioRight}}</p>
                    <p>得 分：{{testInfo.radioScore}}</p>
                </Card>
            </Col>
            <Col span="6">
                <Card dis-hover>
                    <p slot="title">多选题</p>
                    <p>题目总数：{{testInfo.multipleCount}}</p>
                    <p>正确数量：{{testInfo.multipleRate}}</p>
                    <p>正确率：{{testInfo.multipleRight}}</p>
                    <p>得 分：{{testInfo.multipleScore}}</p>
                </Card>
            </Col>  
        </div>
    </Row>
    <div class="footer">
        <Button type="primary" @click="goBack">退出考试</Button>   
    </div>
</div>

</template>
<script>
export default {
//import引入的组件需要注入到对象中才能使用
components: {},
data() {
//这里存放数据
return {
  testInfo:{},//试题结果
};
},
activated(){
    this.testInfo = JSON.parse(this.$route.query.testInfo)
},
//方法集合
methods: {
  //提交考试结果
  goBack(){
    this.$router.replace({name:'Home'})
  },
},
}
</script>
<style lang='less' scoped>
.testPage{
  height: 98vh;
  padding: 5vw 15vw;
  .resultBox{
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .result{
          display: flex;
          align-items: center;
          justify-content: space-between;
      }
 
      .score{
          width: 20vw;
          height: 20vw;
          border-radius: 50%;
          border: 1vw solid #000;
          margin: 0 auto;
          text-align: center;
          padding: 1.5vw;
          span{
              color: #000;
              font-size: 2vw;
              font-weight: bold;
          }
          p{
              padding: 1vw;
              border-top: 1p x solid #eee;
              margin-top: 1vw;
              font-size: 4vw;
              color:#2d8cf0
          }
      }
  }

  .footer{
    text-align: center;
    padding: .5vw 0;
  }
}
</style>
